export default {
      id: "txt_clear-all-usage",
      viewBox: "0 0 21 20",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#txt_clear-all",
      toString: function () {
        return this.url;
      }
    }